interface EpisodeListProps {
  episodes: number;
  current: number;
  onChange: (episode: number) => void;
  title: string;
}

export default function EpisodeList({ episodes, current, onChange, title }: EpisodeListProps) {
  const list = Array.from({ length: episodes }, (_, index) => index + 1);

  return (
    <div>
      <div className="scrollbar-hide flex gap-2 overflow-x-auto pb-2 lg:flex-wrap lg:overflow-visible">
        {list.map((episode) => (
          <button
            key={episode}
            type="button"
            onClick={() => onChange(episode)}
            aria-label={`播放${title}第${episode}集`}
            className={[
              "flex h-10 w-14 shrink-0 items-center justify-center rounded-md border font-label text-xs transition-colors",
              episode === current
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700",
            ].join(" ")}
          >
            {episode}
          </button>
        ))}
      </div>
    </div>
  );
}